import React from "react";
import * as S from "./Landing.styled";
import studyImage from "assets/MainImage/studyImage.png";
import seminarImage from "assets/MainImage/seminarImage.png";
import sportsImage from "assets/MainImage/sportsImage.png";
import cultureImage from "assets/MainImage/cultureImage.png";
import printImage from "assets/MainImage/printImage.png";

const categories = [
  { icon: studyImage, label: "스터디룸", sub: "집중할 공간이 필요할 때" },
  { icon: seminarImage, label: "세미나실", sub: "함께 발표하고 토론할 때" },
  { icon: sportsImage, label: "체육시설", sub: "활기차게 움직이고 싶을 때" },
  { icon: cultureImage, label: "문화공간", sub: "창의적 활동이 필요할 때" },
  { icon: printImage, label: "프린터 / PC", sub: "빠르게 출력하고 싶을 때" },
];

const features = [
  {
    emoji: "📅",
    title: "원하는 시간에, 원하는 시설을",
    desc: "날짜와 시간대를 선택해 스터디룸부터 체육시설까지 즉시 예약하세요.",
  },
  {
    emoji: "🗺️",
    title: "길을 헤매지 않아도 돼요",
    desc: "캠퍼스 지도에서 건물과 시설 위치를 한눈에 확인할 수 있어요.",
  },
  {
    emoji: "🔔",
    title: "중요한 순간을 놓치지 마세요",
    desc: "예약 확정부터 반납 마감까지, 꼭 필요한 알림을 정확하게 보내드려요.",
  },
  {
    emoji: "💬",
    title: "실제 후기로 고르세요",
    desc: "같은 학교 학생들의 리뷰와 실시간 혼잡도로 가장 적합한 시설을 선택하세요.",
  },
];

const Landing: React.FC = () => {
  return (
    <S.Page>

      {/* ── Hero ─────────────────────────────────────────── */}
      <S.Hero>
        <S.HeroGlow />
        <S.HeroGlow2 />

        <S.LiveBadge>
          <S.LiveDot />
          실시간 시설 현황 제공 중
        </S.LiveBadge>

        <S.ServiceName>지금 우리 학교는</S.ServiceName>

        <S.HeroTitle>
          지금,<br />
          우리 학교는<br />
          <span className="accent">어디든 열려있어요</span>
        </S.HeroTitle>

        <S.HeroSub>
          캠퍼스 안의 모든 시설을<br />
          언제든, 어디서든 예약하세요.
        </S.HeroSub>

        <S.CtaGroup>
          <S.PrimaryButton to="/login">시작하기</S.PrimaryButton>
          <S.SecondaryButton to="/signup">계정 만들기</S.SecondaryButton>
        </S.CtaGroup>

        <S.ScrollHint>
          <S.ScrollLabel>scroll</S.ScrollLabel>
          <S.ScrollLine />
        </S.ScrollHint>
      </S.Hero>

      {/* ── Categories ───────────────────────────────────── */}
      <S.Section>
        <S.Label>Facilities</S.Label>
        <S.SectionTitle>어떤 공간이<br />필요하신가요?</S.SectionTitle>

        <S.CategoryList>
          {categories.map((cat) => (
            <S.CategoryRow key={cat.label}>
              <S.CategoryIconBox>
                <img src={cat.icon} alt={cat.label} />
              </S.CategoryIconBox>
              <S.CategoryText>
                <S.CategoryLabel>{cat.label}</S.CategoryLabel>
                <S.CategorySub>{cat.sub}</S.CategorySub>
              </S.CategoryText>
              <S.CategoryArrow>›</S.CategoryArrow>
            </S.CategoryRow>
          ))}
        </S.CategoryList>
      </S.Section>

      {/* ── Features ─────────────────────────────────────── */}
      <S.Section light>
        <S.Label>Features</S.Label>
        <S.SectionTitle dark>이런 게 가능해요</S.SectionTitle>

        <S.FeatureList>
          {features.map((f, i) => (
            <S.FeatureItem key={f.title}>
              <S.FeatureNumber>0{i + 1}</S.FeatureNumber>
              <S.FeatureContent>
                <S.FeatureTitle>{f.title}</S.FeatureTitle>
                <S.FeatureDesc>{f.desc}</S.FeatureDesc>
              </S.FeatureContent>
              <S.FeatureEmoji>{f.emoji}</S.FeatureEmoji>
            </S.FeatureItem>
          ))}
        </S.FeatureList>
      </S.Section>

      {/* ── Bottom CTA ───────────────────────────────────── */}
      <S.CtaSection>
        <S.CtaGlow />
        <S.CtaTitle>지금 바로<br />시작해볼까요?</S.CtaTitle>
        <S.CtaSub>
          학교 이메일 하나로 가입하고<br />
          캠퍼스의 모든 시설을 내 손안에.
        </S.CtaSub>
        <S.CtaGroup>
          <S.PrimaryButton to="/login">로그인</S.PrimaryButton>
          <S.SecondaryButton to="/signup">회원가입</S.SecondaryButton>
        </S.CtaGroup>
      </S.CtaSection>

      <S.Footer>
        <p>
          지금 우리 학교는<br />
          © 2024 · 대학 시설 예약 서비스
        </p>
      </S.Footer>

    </S.Page>
  );
};

export default Landing;
